import { Grid, WithStyles, withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { COURSE_ICON_MAP, IMAGE_BASE_URL } from '../Constants/constants';
import { format } from "date-fns";
import { Package } from '../types/interfaces/CourseBasicDetails';
import { DATE_FORMAT } from '../../../constants/comman';
import courseCardStyles from '../styles/CourseCardForRequestStyles';
import { withRouter } from 'react-router';
import { redirectToCourseRequest } from '../helpers/helpers';
import { isEmpty } from '../../../utils';

interface CourseManagementContainerProps extends WithStyles<typeof courseCardStyles> {
    packageDetails: any;
    history: any;
}
class CourseCardForRequest extends Component<CourseManagementContainerProps>{

    getCourseIcon(packageDetails: any) {
        const courseType = packageDetails.type || packageDetails.courseType;
        const imageUrl = `${IMAGE_BASE_URL}${COURSE_ICON_MAP[courseType]}.svg`;
        return (<img id={packageDetails._id} src={imageUrl} className='courseIcon' alt='Course Book' />);
    }

    getFormattedDate(date: string) {
        return date ? format(new Date(date), DATE_FORMAT.DD_MMM_YYYY) : '';
    }

    handleCardClick = () => {
        const packageData = this.props.packageDetails;
        if (!packageData) {
            return;
        }
        const redirectUrl = redirectToCourseRequest(packageData);
        this.props.history.push(redirectUrl);
    }

    getFullName(requester: any) {
        return isEmpty(requester) ? '' : requester.firstName + ' ' + requester.lastName;
    }

    getRequesterName(packageDetails: any) {
        if (isEmpty(packageDetails) || isEmpty(packageDetails.requestedFrom)) {
            return '';
        }
        return packageDetails.requestedFrom.name || '';
    }

    render() {
        const { classes, packageDetails } = this.props;
        const courseNameArray = (packageDetails.courseDetails || []).map((courseDetails: any) => courseDetails.courseName);
        const courseName = courseNameArray.join(', ');
        return (
            <Grid container onClick={this.handleCardClick}>
                <Grid item xs={12}>
                    <div className={classes.coursePlanChangeRequestRow}>
                        <div className='coursePlanChangeRequestCol'>
                            <div className='coursePlanName'>
                                <h2 title={`${packageDetails.name} | ${packageDetails.sku}`}>{`${packageDetails.name} | ${packageDetails.sku}`}</h2>
                            </div>
                            <div className='courseNameRow'>
                                <div className='courseNameCol'>
                                    {this.getCourseIcon(packageDetails)}
                                    <span>{courseName}</span>
                                </div>
                                <div className='courseDate'>
                                    {this.getFormattedDate(packageDetails.startDate)} <span>to</span> {this.getFormattedDate(packageDetails.expiryDate)}
                                </div>
                            </div>
                            {/* Waiting for backend  for property */}
                            <ul className='requestedList'>
                                <li>Requested By: <span>{this.getFullName(packageDetails.requestedBy)}</span></li>
                                <li>Requested From: <span>{this.getRequesterName(packageDetails)}</span></li>
                                <li>Requested On: <span>{this.getFormattedDate(packageDetails.createdAt)}</span></li>
                            </ul>
                        </div>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

// @ts-ignore
export default withRouter(withStyles(courseCardStyles)(CourseCardForRequest));